export enum addressTypes {
  BILLING = "hardwareDelivery.BILLING",
  EXISTING = "hardwareDelivery.EXISTING",
}
